import type { Option } from '@/types/option'

import { httpClient } from '../../httpClient'

type ListFiltersIdea = {
  workflows: Option[]
  status: Option[]
  challenges: Option[]
  tags: Option[]
}

export async function listFiltersIdea(): Promise<ListFiltersIdea> {
  const { data } = await httpClient.get<{ filters: ListFiltersIdea }>(
    `ideas/ideas/filters`,
  )

  return data.filters
}
